/**
 * Where a student finishes each prerequisite, by canonical item key (apps/universities/prerequisite_catalog.py).
 * Routes follow TransitionU_Course_Package_Plan.xlsx ("Your route"): transcripted college courses finish
 * with Capella, ACE and CLEP courses run on Sophia Learning, and prep, exam prep and certifications are
 * Transition courses. Links are demo links for now; swap the hrefs when the partner deep links are ready.
 */
import capellaLogo from '@/assets/images/partners/capella.svg';
import sophiaLogo from '@/assets/images/partners/sophia-header.svg';
import transitionLogo from '@/assets/images/logos/logo_icon.png';

export const PREREQ_PARTNERS = {
  capella: {
    name: 'Capella University',
    logo: capellaLogo,
    sub: 'College credit on a Capella transcript',
    cta: 'Finish with Capella',
    href: 'https://www.capella.edu/online-nursing-degrees/',
  },
  sophia: {
    name: 'Sophia Learning',
    logo: sophiaLogo,
    sub: 'Self paced online course with ACE credit',
    cta: 'Take it on Sophia',
    href: 'https://www.sophia.org/online-courses/all-courses/',
  },
  transition: {
    name: 'Transition',
    logo: transitionLogo,
    sub: 'Course on your path, right here in the portal',
    cta: 'Start with Transition',
    href: 'https://jointransition.com/',
  },
};

const CAPELLA_FIRST = ['capella', 'sophia'];
const SOPHIA_FIRST = ['sophia', 'capella'];
const TRANSITION = ['transition'];

export const PREREQ_ROUTES = {
  // College partner: transcripted lab sciences
  ap1: CAPELLA_FIRST, ap2: CAPELLA_FIRST, micro: CAPELLA_FIRST, bio: CAPELLA_FIRST, chem: CAPELLA_FIRST,
  patho: ['capella'], pharm: ['capella'], physics: ['capella'],
  // CLEP first and ACE courses
  comp1: SOPHIA_FIRST, comp2: SOPHIA_FIRST, math: SOPHIA_FIRST, stats: SOPHIA_FIRST,
  psych: SOPHIA_FIRST, devpsych: SOPHIA_FIRST, soc: SOPHIA_FIRST, nutrition: SOPHIA_FIRST,
  speech: SOPHIA_FIRST, humanities: SOPHIA_FIRST, gov_history: SOPHIA_FIRST, computer: SOPHIA_FIRST,
  medterm: SOPHIA_FIRST,
  // Transition: college success, exam prep, certifications
  success: TRANSITION,
  teas: TRANSITION, hesi: TRANSITION, placement: TRANSITION, kaplan: TRANSITION, pax: TRANSITION,
  hsrt: TRANSITION, readiness: TRANSITION, wonderlic: TRANSITION, atdh: TRANSITION,
  cna: TRANSITION,
};

/** The partners a student can finish this prereq with, best first. Empty when there is no course for it. */
export function prereqOptions(key) {
  return (PREREQ_ROUTES[key] || []).map(id => ({ id, ...PREREQ_PARTNERS[id] }));
}
